import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BtrEventModel } from '@app/core/models';
import { EventsService } from '@app/core/services/events.service';
import { StorageService } from '@app/core/services/storage.service';
import { BtrEventApiService } from '@app/shared/services/api';

@Component({
  selector: 'app-your-tickets',
  templateUrl: './your-tickets.component.html',
  styleUrls: ['./your-tickets.component.scss'],
})
export class YourTicketsComponent implements OnInit, OnDestroy {
  @Input() wlMode = false;
  @Input() boxBtnMode = false;
  @Input() opened = false;

  @Output()
  toggleMenu: EventEmitter<boolean | void> = new EventEmitter();

  activeEvents: Array<BtrEventModel> = [];
  redeemedEvents: Array<BtrEventModel> = [];
  count = 0;

  private destroy$: Subject<void> = new Subject();

  constructor(
    private storageService: StorageService,
    private eventsService: EventsService,
    private btrEventApiService: BtrEventApiService,
  ) {}

  ngOnInit(): void {
    this.initComponent();
    this.eventsService.ticketPurchaseComplete$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        if (value) {
          this.initComponent();
          this.eventsService.ticketPurchaseCompleteSet(false);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  openPopup(event: MouseEvent): void {
    event.stopPropagation();
    this.toggleMenu.next();
  }

  private initComponent(): void {
    this.btrEventApiService
      .getEvents({
        output_fields: ['tickets', 'tickets.status', 'beacons'].join(','),
      })
      .subscribe(events => {
        this.redeemedEvents = [];
        this.activeEvents = [];
        this.count = events.length;
        for (const event of events) {
          if (event._tickets && event._tickets.length > 0) {
            for (const ticket of event._tickets) {
              if (ticket.statuses && ticket.statuses.length > 0) {
                for (const status of ticket.statuses) {
                  switch (status.status) {
                    case 'verified':
                      this.redeemedEvents.push(event);
                      break;
                    case 'granted':
                    case 'purchased':
                      this.activeEvents.push(event);
                      break;
                  }
                }
              }
            }
          }
        }
      });
  }
}
